module.exports = __webpack_public_path__ + "static/Icon-5cdacf841cf1763ca1853239f881624e.jpg";